<template>
  <div>
    <meta name="app" content="default">
    <b-navbar toggleable type="light" variant="light">
        <b-navbar-brand to="/">Jurnal Amari Covid-19</b-navbar-brand>
        <b-nav pills left v-if="token !== null">
          <b-nav-item to="/">
           Report
          </b-nav-item>
          <b-nav-item to="/users">
           Users
          </b-nav-item>
          <b-nav-item to="/map">
           Map
          </b-nav-item>
          <b-nav-item active v-on:click="logout()">
            Keluar
          </b-nav-item>
        </b-nav>
    </b-navbar>
    <div id="app">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  computed: {
    token () {
      return this.$store.state.authentication.token
    },
    getRole () {
      return this.$store.state.authentication.role
    }
  },
  methods: {
    logout: async function () {
      this.$store.dispatch('authentication/logout')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue